export class ResearchParticipant {
  participantId = 0;
  patientId = "";
  researchDay1 = "";
  dob = "";
  gender = "";
  dsm5 = "";
  watchId = "";
  version = "";
  medication = "";
  medicationId?: number;
  induction = "";
  phoneNumber?: string;
  select = false;
  show = false;
  status = 0;
}

export const SETTINGS = {
  NONE: "none",
  NOTIFICATION: "notification",
  SHOW_HIDE: "showHide"
}

export const DISPLAY = {
  SHOW: "Visible",
  HIDE: "Hidden"
}